<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal ref="modal" size="sm" centered>
      <form ref="form" @submit="save">
        <fields
          :fields="fields.all()"
          :model="model"
          :errors="errors"
          layout="vertical"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import BookingsApi from './Api'

export default {
  name: 'Assigning',

  mixins: [FormMixin],

  props: {
    // eslint-disable-next-line vue/require-default-prop
    booking: Object,
  },

  data() {
    return {
      model: {},
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('shown', () => {
      this.$uiBlocker(
        new BookingsApi().assignForm(this.booking).then(result => {
          this.model = result.data
          this.setFields(result.fields)
        }),
        modal.$refs.content,
      )
    })

    modal.$on('close', () => {
      this.$close()
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.save()
    })

    modal.$on('cancel', () => {
      this.$close()
    })
  },

  methods: {
    save() {
      return this.$uiBlocker(
        new BookingsApi()
          .assign(this.booking, this.model)
          .then(result => {
            this.$refs.modal.hide()
            this.$close(this.model)
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
